export default __webpack_public_path__ + "static/media/Snd4.363ed4a8.mp3";